export const round = (num: number) => Math.round(num * 100) / 100
